// Library Methods
import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Alert from "src/components/shared/alerts/Alert/Alert";

// Contexts
import { ReportContext } from "src/contexts/reports/ReportContext";
import { ReportSectionContext } from "src/contexts/reports/ReportSectionContext";

// Utils
import { isTerminatedExamReport } from "src/utils/exams/examReportsHelper";

// Constants
import { examCardEnums } from "src/constants/enums";

const VideoGraph = () => {
  const { t } = useTranslation();

  const { exam } = useContext(ReportContext);
  const { examReport } = useContext(ReportSectionContext);

  const isTerminated = useMemo(
    () =>
      isTerminatedExamReport({
        exam,
        examReport,
        sectionName: examCardEnums.VIDEO.sectionName,
      }),
    [exam, examReport]
  );

  const videoData = useMemo(
    () => examReport?.state?.videoData,
    [examReport?.state?.videoData]
  );

  return (
    <Grid container gap="20px">
      {isTerminated && (
        <Alert
          variant="error"
          alertContent={t("Terminated Exam")}
          props={{ width: "100%" }}
        />
      )}

      <Grid
        item
        xs={12}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          <Typography sx={{ fontSize: "14px" }}>
            {t("The patient watched the following video")}:
          </Typography>
          <Box
            component="ul"
            sx={{
              columns: "auto",
              columnWidth: "200px",
              listStyle: "disc",
              paddingLeft: "20px",
              textAlign: "left",
              fontSize: "14px",
            }}
          >
            {videoData ? (
              <li>{videoData?.videoName}</li>
            ) : (
              <li>{t("No video found.")}</li>
            )}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default VideoGraph;
